<canvas *ngIf="!readonly" #canvas class="signature-pad-canvas" (touchend)="endDrawing($event)"
    (mouseup)="endDrawing($event)"> </canvas>
<div *ngIf="!readonly" class="signature-info">{{ 'SIGNATURE.INFO' | translate}}</div>
<div *ngIf="!readonly" class="signature-clear" (click)="onClearSignature()">{{ 'SIGNATURE.CLEAR' | translate}}</div>
<img *ngIf="readonly && imageSrc" [src]="imageSrc" alt="Image" />
<div class="invalida no-justsignature">{{'SHARED.SIGNATURE.COMPONENT.INVALID.TITLE'|translate}}</div>